import { BinType } from 'commons/enums';
import { ProductDetail, STOItem } from 'commons/types';

import { SwipeRxWmsApi } from '../resources';
import { SwipeRxAPIResources } from '../resources/types';
import {
  IPickingJobProductDetailRequest,
  IPickingJobProductDetailResponse,
} from '../SwipeRxWmsApiPickJob/types';
import { STOReceiveItemRequest } from '../SwipeRxWmsApiStoReceiveItem/type';

import {
  ISTOCompletePickItem,
  ISTOPickedItemRequest,
  ISTOPickRemoveBatchRequest,
  ISTOPickVerifyBasketRequest,
} from './types';

class SwipeRxWmsApiStoPickItem extends SwipeRxWmsApi {
  constructor() {
    super(SwipeRxAPIResources.STO_PICK_ITEM);
  }

  async getSTOPickItemList(): Promise<STOItem[]> {
    try {
      const result = await this.get(`${this.apiResource}/list`, undefined);
      if (!result.data) throw new Error('[FEError] Data not found');
      return result.data;
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }

  async getSTOAssignedPickItems(): Promise<STOItem[]> {
    try {
      const result = await this.get(`${this.apiResource}/assigned`, undefined);
      if (!result.data) throw new Error('[FEError] Data not found');
      return result.data;
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }

  async assignSTOPickItem(): Promise<STOItem[]> {
    try {
      const result = await this.post(
        `${this.apiResource}/assign/new`,
        undefined,
      );
      if (!result.data) throw new Error('[FEError] Data not found');
      return result.data;
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }

  async addSTOPickItem(): Promise<STOItem> {
    try {
      const result = await this.post(
        `${this.apiResource}/assign/add`,
        undefined,
      );
      if (!result.data) throw new Error('[FEError] Data not found');
      if (result.data.length === 0)
        throw new Error('No Item available for picking right now');
      return result.data[0];
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }

  async startPickingProcess(items: STOReceiveItemRequest[]): Promise<string> {
    try {
      const result = await this.post(`${this.apiResource}/start`, {
        items,
      });
      if (!result.data) throw new Error('[FEError] Data not found');
      return result.data;
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }

  async removeSTOPickItem(payload: STOReceiveItemRequest) {
    try {
      const result = await this.patch(
        `${this.apiResource}/assign/remove`,
        payload,
      );
      if (!result.data) throw new Error('[FEError] Data not found');
      return result.data;
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }

  async getBinRecommendationInfo(
    skuCode: string,
    binType: BinType,
  ): Promise<ProductDetail[]> {
    const result = await this.get(
      `${this.apiResource}/${skuCode}/bin-recommendation/${binType}/info`,
    );

    return result.data;
  }

  async postPickedItem(params: ISTOPickedItemRequest): Promise<boolean> {
    try {
      await this.post(`${this.apiResource}/pick-item`, params);
      return true;
    } catch (error) {
      return false;
    }
  }

  async postRemoveBatch(params: ISTOPickRemoveBatchRequest): Promise<void> {
    await this.post(`${this.apiResource}/remove-batch`, params);
  }

  async postVerifyBasket(params: ISTOPickVerifyBasketRequest): Promise<void> {
    await this.post(`${this.apiResource}/verify`, params);
  }

  async postCompletePicking(params: ISTOCompletePickItem): Promise<void> {
    await this.post(`${this.apiResource}/complete`, params);
  }

  async getProductDetail(params: IPickingJobProductDetailRequest): Promise<{
    error?: string | true;
    data?: IPickingJobProductDetailResponse;
  }> {
    try {
      const result = await this.get(
        `${this.apiResource}/product-detail`,
        params,
      );
      const data = result.data as IPickingJobProductDetailResponse;
      return { data };
    } catch (error: unknown) {
      if (error instanceof Error) {
        return { error: error.message };
      }
      return { error: true };
    }
  }
}

export const swipeRxWmsApiStoPickItem = new SwipeRxWmsApiStoPickItem();
